export const DashboardAPI = {};

const SLICE = 'dashboard';



DashboardAPI.item = (onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/dashboard`,
    method:    'GET',
    slice:     SLICE,
    action:    'item',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};
